import { render, staticRenderFns } from "./NominaPromofarma.vue?vue&type=template&id=27a9f406&"
import script from "./NominaPromofarma.vue?vue&type=script&lang=js&"
export * from "./NominaPromofarma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports